// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__5QakG","info":"UpdateTermsInfo_info__1iHo_"};